import http from './ajax.js'
import notice from './notice.js'
import Fingerprint2 from 'fingerprintjs2';

const browser = {
  versions: function () {
    var u = navigator.userAgent;
    return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Firefox') > -1, //火狐内核Gecko
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android
      iPhone: u.indexOf('iPhone') > -1, //iPhone
      iPad: u.indexOf('iPad') > -1, //iPad
      webApp: u.indexOf('Safari') > -1, //Safari
      user: u,
    };
  }()
}
// 随机id当做设备标识
function randomRangeId(num = 8) {
  var returnStr = "",
    charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < num; i++) {
    var index = Math.round(Math.random() * (charStr.length - 1));
    returnStr += charStr.substring(index, index + 1);
  }
  localStorage.setItem("bps_device_no", returnStr);
  return returnStr;
};
if (!localStorage.getItem('bps_device_no')) {
  randomRangeId();
}
// 工具
var tools = {
  android: browser.versions.android,//安卓
  trident: browser.versions.trident, //IE内核
  presto: browser.versions.presto, //opera内核
  webKit: browser.versions.webKit, //苹果、谷歌内核
  gecko: browser.versions.gecko, //火狐内核Gecko
  mobile: browser.versions.mobile, //是否为移动终端
  ios: browser.versions.ios, //ios
  iPhone: browser.versions.iPhone, //iPhone
  iPad: browser.versions.iPad, //iPad
  webApp: browser.versions.webApp, //Safari
  user: browser.versions.user, //Safari
  // 设置网页标题
  setWebTitle(title) {
    console.log("setWebTitle", title);
    setTimeout(function () {
      document.getElementsByTagName("title")[0].innerText = title;
    }, 100)
  },
  // 获取meta标签
  getMetaValue(k) {
    var metaList = document.getElementsByTagName("meta");
    for (var i = 0; i < metaList.length; i++) {
      if (metaList[i].getAttribute("name") == k) {
        return metaList[i].getAttribute("content");
      }
    }
  },
  //微信
  isWeiXin: function () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  //支付宝环境
  isAL: function () {
    var ua = navigator.userAgent.toLowerCase();

    if (ua.match(/Alipay/i) == "alipay") {
      return true;
    } else {
      return false;
    }
  },

  //百度app环境
  isBaidu: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/Baiduboxapp/i) == "baiduboxapp") {
      return true;
    } else {
      return false;
    }
  },

  //今日头条环境
  isNewSarticle: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/Newsarticle/i) == "newsarticle") {
      return true;
    } else {
      return false;
    }
  },

  //抖音环境
  isDouYin: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/Aweme/i) == "aweme") {
      return true;
    } else {
      return false;
    }
  },

  //过滤空格
  trim: function (val) {
    return val.replace(/(^\s*)|(\s*$)/g, "");
  },
  //获取安卓版本号
  getAnbanben: function () {
    var user = this.user;
    var index = user.indexOf("Android");
    if (index > 0) {
      return parseFloat(user.slice(index + 8));
    } else {
      return null;
    }
  },
  // 获取html名称
  pageName: function () {
    var a = location.href;
    var b = a.split("/");
    var c = b.slice(b.length - 1, b.length).toString(String).split(".");
    return c.slice(0, 1);
  },
  //判断是数组
  isArray(o) {
    return Object.prototype.toString.call(o) == '[object Array]';
  },
  //判断null
  isNull: function (exp) {
    if (!exp && typeof exp != "undefined" && exp != 0) {
      return true;
    } else if (exp == "null") {
      return true;
    }
    return false;
  },
  //删除地址栏参数
  delQueStr: function (url, ref) {
    var str = "";
    if (url.indexOf('?') != -1) {
      str = url.substr(url.indexOf('?') + 1);
    }
    else {
      return url;
    }
    var arr = "";
    var returnurl = "";
    var setparam = "";
    if (str.indexOf('&') != -1) {
      arr = str.split('&');
      for (var i in arr) {
        if (arr[i].split('=')[0] != ref) {
          returnurl = returnurl + arr[i].split('=')[0] + "=" + arr[i].split('=')[1] + "&";
        }
      }
      return url.substr(0, url.indexOf('?')) + "?" + returnurl.substr(0, returnurl.length - 1);
    }
    else {
      arr = str.split('=');
      if (arr[0] == ref) {
        return url.substr(0, url.indexOf('?'));
      }
      else {
        return url;
      }
    }
  },
  //获取cookie
  getcookie: function (name) {
    var strcookie = document.cookie;
    var arrcookie = strcookie.split("; ");
    for (var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == name) return decodeURIComponent(arr[1]);
    }
    return "";
  },
  //设置本地储存
  setLocal: function (name, value, type) {
    var curTime = new Date().getTime();
    if (!type || type == 2) { //默认设置-之前存在则使用创建时间
      var data = localStorage.getItem(name);
      if (!data || data == "null") {
        localStorage.setItem(name, JSON.stringify({
          data: value,
          time: curTime
        }));
      } else {
        var dataObj = JSON.parse(data);
        var setTime = dataObj.time;
        localStorage.setItem(name, JSON.stringify({
          data: value,
          time: setTime
        }));
      }
    } else if (type == 1) { //type:1重新创建
      localStorage.setItem(name, JSON.stringify({
        data: value,
        time: curTime
      }));
    }

  },
  //获取本地储存
  getLocal: function (name, exp) {
    var data = localStorage.getItem(name);
    var dataObj = JSON.parse(data);
    if (!exp) {
      var exp = 1000 * 60 * 60 * 24 * 3;
    }
    if (dataObj && new Date().getTime() - dataObj.time > exp) {
      localStorage.removeItem(name);
      console.log('信息已过期');
      return null;
    } else {
      var dataObjDatatoJson = !dataObj ? null : dataObj.data;
      return dataObjDatatoJson;
    }
  },

  /*
  * 深复制
  * params
  * -destination  被赋值的新对象
  * -source  取值的对象
  * -miss  忽略的对象
  * */
  deepCopy: function (destination, source, miss) {
    for (var p in source) {
      if (_.isArray(p, miss) > -1) {
        return;
      }
      if (getType(source[p]) == "array" || getType(source[p]) == "object") {
        destination[p] = getType(source[p]) == "array" ? [] : {};
        arguments.callee(destination[p], source[p]);
      }
      else {
        destination[p] = source[p];
      }
    }
    function getType(o) {
      var _t;
      return ((_t = typeof (o)) == "object" ? o == null && "null" || Object.prototype.toString.call(o).slice(8, -1) : _t).toLowerCase();
    }
  },
  isDD: function () {
    //判断是不是钉钉
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("dingtalk") >= 0;
  },
  cutString: function (content, length) {
    //截取字符串  根据字符是否为圆角字符来记数
    var _ret = this.getCutValue(content, length)
    var _cutFlag = _ret.cutflag;
    var _cutStringn = _ret.cutstring;
    if (_cutFlag) {
      return _cutStringn + "...";
    } else {
      return _cutStringn;
    }
  },
  getCutValue: function (pStr, pLen) {
    // 原字符串长度
    var self = this;
    var _strLen = pStr.length;
    var _tmpCode;
    var _cutString;
    // 默认情况下，返回的字符串是原字符串的一部分
    var _cutFlag = true;
    var _lenCount = 0;
    var _ret = false;

    if (_strLen <= pLen / 2) {
      _cutString = pStr;
      _ret = true;
    }
    if (!_ret) {
      for (var i = 0; i < _strLen; i++) {
        if (self.isFull(pStr.charAt(i))) {
          _lenCount += 2;
        } else {
          _lenCount += 1;
        }
        if (_lenCount > pLen) {
          _cutString = pStr.substring(0, i);
          _ret = true;
          break;
        } else if (_lenCount == pLen) {
          _cutString = pStr.substring(0, i + 1);
          _ret = true;
          break;
        }
      }
    }
    if (!_ret) {
      _cutString = pStr;
      _ret = true;
    }

    if (_cutString.length == _strLen) {
      _cutFlag = false;
    }
    return { "cutstring": _cutString, "cutflag": _cutFlag };
  },
  isFull: function (pChar) {
    //是否全角文字
    if ((pChar.charCodeAt(0) > 128)) {
      return true;
    } else {
      return false;
    }
  },
  getStorage(key, isString) {
    if (localStorage[key]) {
      let out = localStorage[key];
      if (!isString) {
        try {
          out = JSON.parse(localStorage[key])
        } catch (error) {
          console.log("解析localStorage." + key + "失败", error);
        }
      }
      return out;
    }
  },
  setStorage(key, data) {
    if (typeof data == "object") {
      try {
        data = JSON.stringify(data);
      } catch (error) {
        console.log("解析localStorage." + key + "失败", error);
      }
    }
    localStorage.setItem(key, data);
  },
  dateFormat(date,fmt="yyyy-MM-dd"){
    let ret;
    const opt = {
      "y+": date.getFullYear().toString(),        // 年
      "M+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "h+": date.getHours().toString(),           // 时
      "m+": date.getMinutes().toString(),         // 分
      "s+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      }
    }
    return fmt;
  },
  // 文件下载
 download(res, type, filename) {
    // 创建blob对象，解析流数据
    const blob = new Blob([res], {
      // 如何后端没返回下载文件类型，则需要手动设置：type: 'application/pdf;chartset=UTF-8' 表示下载文档为pdf，如果是word则设置为msword，excel为excel
      // type: 'application/pdf;chartset=UTF-8'
      type:type
    })
    const a = document.createElement('a')
    // 兼容webkix浏览器，处理webkit浏览器中href自动添加blob前缀，默认在浏览器打开而不是下载
    const URL = window.URL || window.webkitURL
    // 根据解析后的blob对象创建URL 对象
    const herf = URL.createObjectURL(blob)
    // 下载链接
    a.href = herf
    // 下载文件名,如果后端没有返回，可以自己写a.download = '文件.pdf'
    // a.download = filename
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    // 在内存中移除URL 对象
    window.URL.revokeObjectURL(herf)
  },
  // 复制文本
  copyText(text) {
    const cInput = document.createElement('input')
    cInput.value = text;
    document.body.appendChild(cInput)
    // 选取文本域内容;
    cInput.select()
    // 执行浏览器复制命令
    // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
    // Input要在正常的编辑状态下原生复制方法才会生效
    document.execCommand('Copy')
    notice.msg('复制成功')
    /// 复制成功后再将构造的标签 移除
    cInput.remove()
  },
  getDeviceKey(){
    return new Promise((resolve, reject) => {
      // 去掉不稳定的参数
      const options =  Fingerprint2.Options = {
        excludes: {
          language: true,
          colorDepth: true,
          deviceMemory: true,
          pixelRatio: true,
          availableScreenResolution: true,
          timezoneOffset: true,
          timezone: true,
          sessionStorage: true,
          localStorage: true,
          indexedDb: true,
          addBehavior: true,
          openDatabase: true,
          cpuClass: true,
          doNotTrack: true,
          plugins: true,
          canvas: true,
          webglVendorAndRenderer: true,
          adBlock: true,
          hasLiedLanguages: true,
          hasLiedResolution: true,
          hasLiedOs: true,
          hasLiedBrowser: true,
          touchSupport: true,
          audio: false,
          enumerateDevices: true,
          hardwareConcurrency: true,
        },
      };
      // 延迟获取避免不稳定
      window.setTimeout(()=>{
        Fingerprint2.get(options, (components) => { // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
          const values = components.map(component => component.value); // 配置的值的数组
          const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
          sessionStorage.setItem('devicekey', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
          resolve(murmur);
        });
      }, 500);
    });
  },
  async phoneSignature() {
    const deviceNo = localStorage.getItem('bps_device_no');
    const p = new Promise((resolve, reject) => {
      http({
        url: "/api/bplat/getSignature",
        type: "PUT",
        data: {},
        headers: {
          deviceNo: deviceNo
        }
      }).then((res) => {
        resolve(res.data)
      });
    });
    const result = await p;
    return result;
  }
};
window.getMetaValue = tools.getMetaValue;
export default tools
